import { axiosInstance, axiosCompanyPortalInstance } from "./";

const getAdminPayrolls = async ({ eventId, params }) =>
  await axiosInstance.get(`/events/${+eventId}/payrolls`, { params });

const getCompanyPayrolls = async ({ eventId, params }) =>
  await axiosCompanyPortalInstance.get(`/events/${+eventId}/payrolls`, {
    params,
  });

const getAdminUserPayroll = async ({ eventId, userId }) =>
  await axiosInstance.get(`/events/${+eventId}/payrolls/${+userId}`);

const getCompanyUserPayroll = async ({ eventId, userId }) =>
  await axiosCompanyPortalInstance.get(
    `/events/${+eventId}/payrolls/${+userId}`,
  );

const getAdminPayrollAdjustments = async ({ eventId, params }) =>
  await axiosInstance.get(`/events/${+eventId}/payroll_adjustments`, {
    params,
  });

const getCompanyPayrollAdjustments = async ({ eventId, params }) =>
  await axiosCompanyPortalInstance.get(
    `/events/${+eventId}/payroll_adjustments`,
    { params },
  );

const getAdminPayrollPaymentCounts = async ({ eventId, params }) =>
  await axiosInstance.get(`/events/${+eventId}/payrolls/payment_counts`, {
    params,
  });

const getCompanyPayrollPaymentCounts = async ({ eventId, params }) =>
  await axiosCompanyPortalInstance.get(
    `/events/${+eventId}/payrolls/payment_counts`,
    { params },
  );

const createAdminUserEventPayment = async ({ eventId, userId, paymentProofUrl }) =>
  await axiosInstance.post(`/events/${+eventId}/user_event_payments`, {
    user_id: userId,
    payment_proof_url: paymentProofUrl,
  });

const createCompanyUserEventPayment = async ({ eventId, userId, paymentProofUrl }) =>
  await axiosCompanyPortalInstance.post(`/events/${+eventId}/user_event_payments`, {
    user_id: userId,
    payment_proof_url: paymentProofUrl,
  });

const bulkCreateAdminUserEventPayments = async ({ eventId, userIds, paymentProofUrl }) =>
  await axiosInstance.post(`/events/${+eventId}/user_event_payments/bulk_create`, {
    user_ids: userIds,
    payment_proof_url: paymentProofUrl,
  });

const bulkCreateCompanyUserEventPayments = async ({ eventId, userIds, paymentProofUrl }) =>
  await axiosCompanyPortalInstance.post(
    `/events/${+eventId}/user_event_payments/bulk_create`,
    {
      user_ids: userIds,
      payment_proof_url: paymentProofUrl,
    },
  );

const logAdminPayrollExport = async ({ eventId, body }) =>
  await axiosInstance.post(
    `/events/${+eventId}/payrolls/log_payroll_export`,
    body,
    { handlerEnabled: false },
  );

const logCompanyPayrollExport = async ({ eventId, body }) =>
  await axiosCompanyPortalInstance.post(
    `/events/${+eventId}/payrolls/log_payroll_export`,
    body,
    { handlerEnabled: false },
  );

export {
  logAdminPayrollExport,
  logCompanyPayrollExport,
  getAdminPayrolls,
  getCompanyPayrolls,
  getAdminUserPayroll,
  getCompanyUserPayroll,
  getAdminPayrollAdjustments,
  getCompanyPayrollAdjustments,
  getAdminPayrollPaymentCounts,
  getCompanyPayrollPaymentCounts,
  createAdminUserEventPayment,
  createCompanyUserEventPayment,
  bulkCreateAdminUserEventPayments,
  bulkCreateCompanyUserEventPayments,
};
